/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Example_Item61Inputs */

const ja_playdata_eventreport_example_item61 = /** @type {(inputs: Playdata_Eventreport_Example_Item61Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲーム別の競合分析`)
};

const en_playdata_eventreport_example_item61 = /** @type {(inputs: Playdata_Eventreport_Example_Item61Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitive analysis by game`)
};

/**
* | output |
* | --- |
* | "Competitive analysis by game" |
*
* @param {Playdata_Eventreport_Example_Item61Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_example_item61 = /** @type {((inputs?: Playdata_Eventreport_Example_Item61Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Example_Item61Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_example_item61(inputs)
	return en_playdata_eventreport_example_item61(inputs)
});
export { playdata_eventreport_example_item61 as "playdata_eventReport_example_item6" }